import { connect } from 'react-redux'
import { actions, selectors } from '../../../../imports'
import {
    // Actions
    togglePinnedForUser,
    toggleMultistartForUser,
    removeUserFromAutoLaunch,
    logOut,

    // Selectors
    isUserPinned,
    shouldUserMultiStart,
    shouldUserAutoLaunch,
    getActiveOrder,
    getProfileTooltipText,
    getStartTooltipText,
    getStopTooltipText,
    getLogOutTooltipText,
    getPinTooltipText,
    getUnPinTooltipText,
} from '../../../../data'
import User from './component'

function mapStateToProps(state, ownProps) {
    const serverId = selectors.getActiveServerId(state)
    const userId = ownProps.userId
    const pinned = isUserPinned(state, serverId, userId)
    const multiStart = shouldUserMultiStart(state, serverId, userId)
    const autoLaunchOnLogin = shouldUserAutoLaunch(state, serverId, userId)
    // Display toggle if more than one user
    const displayToggle = getActiveOrder(state).length > 1

    const launchProgress = selectors.getActiveLaunchProgress(state, userId).percent

    const profileText = getProfileTooltipText(state).replace('{username}', userId)
    const startText = getStartTooltipText(state).replace('{username}', userId)
    const stopText = getStopTooltipText(state).replace('{username}', userId)
    const pinText = getPinTooltipText(state)
    const unPinText = getUnPinTooltipText(state)

    return {
        userId,
        serverId,
        pinned,
        multiStart,
        autoLaunchOnLogin,
        displayToggle,
        launchProgress,
        playEnabled: selectors.getActivePlayable(state),
        isPlaying: selectors.isPlaying(state, userId),
        profileText,
        startClientText: startText,
        stopClientText: stopText,
        removeText: getLogOutTooltipText(state),
        pinText: pinned ? pinText : unPinText,
    }
}

const togglePinned = userId => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(togglePinnedForUser(serverId, userId))
}

const toggleMultiStart = userId => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(toggleMultistartForUser(serverId, userId))
}

const removeAutoLaunch = userId => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(removeUserFromAutoLaunch(serverId, userId))
}

const remove = userId => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(logOut(serverId, userId))
}

const setLaunchProgress = (userId, progress) => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(actions.setClientLaunchProgress(serverId, userId, progress))
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        togglePinned: () => {
            dispatch(togglePinned(ownProps.userId))
        },
        toggleMultiStart: () => {
            dispatch(toggleMultiStart(ownProps.userId))
        },
        removeAutoLaunch: () => {
            dispatch(removeAutoLaunch(ownProps.userId))
        },
        remove: () => {
            dispatch(remove(ownProps.userId))
        },
        setClientLaunchProgress: (progress) => {
            dispatch(setLaunchProgress(ownProps.userId, progress))
        },
        toggleProfileSelector: (boundingRectangle, title) => {
            dispatch(actions.toggleSelector(ownProps.userId, title, boundingRectangle))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(User)



// WEBPACK FOOTER //
// ./src/features/Users/components/UserList/components/User/index.js